import { EPermission } from 'modules/auth/context/permify/permify.interfaces';
import { usePermify } from 'modules/auth/context';
import { NoAccess } from 'app/components';
import { ReactNode } from 'react';

export interface IHasAccessProps {
  children?: ReactNode;
  permission: EPermission;
}

const HasAccess = ({ children, permission }: IHasAccessProps) => {
  const { isAuthorized } = usePermify();

  if (!isAuthorized(permission)) {
    return <NoAccess />;
  }

  return <>{children}</>;
};

export default HasAccess;
